import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiMapPin } = FiIcons;

const CitySearch = ({ cities, selectedCity, onCitySelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const filteredCities = cities.filter(city =>
    city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCitySelect = (city) => {
    onCitySelect(city);
    setSearchTerm('');
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <div className="relative">
        <SafeIcon
          icon={FiSearch}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white/70 w-5 h-5"
        />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          placeholder="Search Philippine cities..."
          className="w-full pl-12 pr-4 py-4 bg-white/20 backdrop-blur-lg rounded-xl border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent"
        />
      </div>

      {isOpen && searchTerm && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="absolute top-full mt-2 w-full bg-white/90 backdrop-blur-lg rounded-xl border border-white/30 shadow-2xl z-50 max-h-60 overflow-y-auto"
        >
          {filteredCities.length > 0 ? (
            filteredCities.map((city) => (
              <button
                key={city}
                onClick={() => handleCitySelect(city)}
                className="w-full px-4 py-3 text-left hover:bg-white/20 transition-colors duration-200 flex items-center space-x-3 text-gray-800 hover:text-gray-900"
              >
                <SafeIcon icon={FiMapPin} className="w-4 h-4 text-blue-600" />
                <span>{city}</span>
              </button>
            ))
          ) : (
            <div className="px-4 py-3 text-gray-500 text-center">
              No cities found
            </div>
          )}
        </motion.div>
      )}

      {isOpen && !searchTerm && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default CitySearch;